import type { Machine, MachineStatus } from '@bridgewerk/shared';
import { StatusDot } from '../../../components/layout/StatusDot.js';
import { Badge } from '../../../components/ui/Badge.js';

const STATUS_LABEL: Record<MachineStatus, string> = {
  running: 'RUNNING',
  idle: 'IDLE',
  alarm: 'ALARM',
  offline: 'OFFLINE',
};

const TONE: Record<MachineStatus, 'opportunity' | 'warning' | 'critical' | 'neutral'> = {
  running: 'opportunity',
  idle: 'warning',
  alarm: 'critical',
  offline: 'neutral',
};

const CONTROLLER_LABEL: Record<string, string> = {
  fanuc_0i_md: 'Fanuc 0i-MD',
  fanuc_30i: 'Fanuc 30i',
  mazak_matrix: 'Mazak Matrix',
  mazak_smoothx: 'Mazak SmoothX',
  haas_nextgen: 'Haas NextGen',
  mori_mapps: 'Mori MAPPS',
  okuma_osp: 'Okuma OSP',
  siemens_840d: 'Siemens 840D',
  heidenhain_tnc: 'Heidenhain TNC',
  unknown: 'Unknown controller',
};

export interface MachineHeaderProps {
  readonly machine: Machine;
}

export function MachineHeader({ machine }: MachineHeaderProps): JSX.Element {
  return (
    <header className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-3">
        <h1 className="font-mono text-xl">{machine.machine_id}</h1>
        <Badge tone={TONE[machine.status]}>
          <StatusDot status={machine.status} size={6} />
          <span className="ml-1.5">{STATUS_LABEL[machine.status]}</span>
        </Badge>
      </div>
      <span className="font-mono text-xs text-text-dim">
        {CONTROLLER_LABEL[machine.controller_type] ?? machine.controller_type}
      </span>
    </header>
  );
}
